import React, { useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridRow,
  GridCell,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import addIdToData from "../../utilities/addIdToData";
import API_BASE_URL from "../../utilities/apiConfig";
import { extractFileNameAndExtension } from "../../utilities/extractFileNameAndExtension";
import axios from "axios";
import convertToUnderscoreFormat from "../../utilities/convertToUnderscoreFormat";
import axiosInstance from "../../utilities/apiConfig";
import Loader from "../Loader";
export default function NewVerifiedMembersDataTable({
  TableData,
  TableColumns,
  tableName,
  height = 450,
}) {
  const DataWithId = addIdToData(TableData);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [profileImage, setProfileImage] = useState("");
  const [loading, setLoading] = useState(false);
  const baseURL = axiosInstance.defaults.baseURL;

  const handleRowClick = async (row) => {
    console.log(row);
    try {
      setLoading(true);
      const formattted_bar_id = convertToUnderscoreFormat(row.advocateBarId);
      const response = await axiosInstance.get(
        `/Verification/get_advocate_photo_using_advocate_bar_id/${formattted_bar_id}`
      );
      console.log(response.data);
      // if (response.data.response.statusCode === 200) {
      //   // setProfileImage(`${baseURL}/Verification/${response.data?.photo}`);
      //   setProfileImage(
      //     `${axiosInstance}/Verification/${response.data?.photo}`
      //   );
      //   // setProfileImage(response.data.photo);
      //   setExpandedRowId(expandedRowId === row.id ? null : row.id);

      // CHANGES BY KHALID STARTS

      if (response.data.response.statusCode === 200) {
        debugger;

        axiosInstance
          .get(`/Verification/${response.data?.photo}`, {
            responseType: "blob", // Ensures we get binary data for the image
          })
          .then((imageResponse) => {
            const imageUrl = URL.createObjectURL(imageResponse.data); // Create URL for the image blob
            setProfileImage(imageUrl); // Set the fetched image URL as the profile image
          })
          .catch((error) => {
            console.error("Error fetching profile image:", error);
            setProfileImage(""); // Clear profile image if there's an error
          });

        setExpandedRowId(
          expandedRowId === row.eligibilityId ? null : row.eligibilityId
        );

        // CHANGES BY KHALID ENDS
      } else {
        setProfileImage("");
      }
    } catch (error) {
      setProfileImage("");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // Added by khalid starts

  const handleViewDocument = async (row, documentType, documentFileName) => {
    debugger; //yahi
    try {
      setLoading(true);
      // Fetch the document with the correct headers and response type for Blob
      const response = await axiosInstance.get(
        `/File/${documentType}/${documentFileName}`,
        { responseType: "blob" }
      );

      // Get the file type (MIME type) from the response
      const fileType = response.headers["content-type"];

      // Create a Blob URL for the fetched file
      const fileURL = URL.createObjectURL(response.data);

      // Handle different file types
      if (fileType.startsWith("image/")) {
        // Open image in a new tab
        window.open(fileURL, "_blank");
      } else if (fileType === "application/pdf") {
        // Open PDF in a new tab
        window.open(fileURL, "_blank");
      } else if (fileType === "text/plain") {
        // Handle text file and display its content
        const text = await response.data.text();
        const textWindow = window.open();
        textWindow.document.write(`<pre>${text}</pre>`);
      } else {
        // For other file types, you can download or display it accordingly
        window.open(fileURL, "_blank");
      }
    } catch (error) {
      console.error("Error viewing document:", error);
      alert("Failed to view document: " + error.message);
    } finally {
      // Set loading state to false after the document fetch attempt (success or failure)
      setLoading(false);
    }
  };

  // Added by khalid ends

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
        <GridToolbarFilterButton
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
        <GridToolbarDensitySelector
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
        {/* <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector
                    slotProps={{ tooltip: { title: 'Change density' } }}
                /> */}

        {/* <Box sx={{ flexGrow: 1 }} /> */}
        <GridToolbarExport
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
      </GridToolbarContainer>
    );
  }

  const columns = TableColumns.map((col) => {
    if (col.field === "name") {
      return {
        ...col,
        renderCell: (params) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar
              src={`https://api.adorable.io/avatars/50/${params.value}.png`}
              style={{ marginRight: 8 }}
            />
            {params.value}
          </div>
        ),
      };
    }
    return col;
  });

  const rows = DataWithId.map((row) => ({
    ...row,
    id: row.id || row.advocateBarId,
  }));

  const renderExpandableContent = (row) => (
    <Collapse in={expandedRowId === row.id} timeout="auto" unmountOnExit>
      <Box margin={1}>
        <div className="p-3 bg-light">
          <h4>Details for {row.name}</h4>
          <div className="row">
            <div className="col-md-3 rounded-5">
              <img src={profileImage} alt="" />
            </div>
            <div className="col-md-3"></div>
            <div className="col-md-6 ">
              <p>
                <strong>Advocate Bar ID:</strong> {row.advocateBarId}{" "}
                {row.advocateAlternateBarId}
              </p>
              <p>
                <strong>Relative Name:</strong> {row.relationshipType} of{" "}
                {row.relativeName}
              </p>
              <p>
                <strong>Mobile No:</strong> {row.mobileNo}
              </p>
              <p>
                <strong>Date of Birth:</strong>{" "}
                {new Date(row.dateOfBirth).toLocaleDateString()}
              </p>
              <p>
                <strong>Email:</strong> {row.email || "N/A"}
              </p>
              <p>
                <strong>Local Address:</strong> {row.localAddress}
              </p>
              <p>
                <strong>Permanent Address:</strong> {row.permanentAddress}
              </p>
              <p>
                <strong>Years of Experience:</strong> {row.yearsOfExperience}
              </p>
              <p>
                <strong>Dehradun Bar Registration Date:</strong>{" "}
                {new Date(
                  row.concernedBarRegistrationDate
                ).toLocaleDateString()}
              </p>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-6">
              <p>
                <strong>Membership Acceptance Date:</strong>{" "}
                {row.acceptedDate
                  ? new Date(row.acceptedDate).toLocaleDateString()
                  : "N/A"}
              </p>
              <p>
                <strong>Blood Group:</strong> {row.bloodGroup || "N/A"}
              </p>
              <p>
                <strong>Mentor Advocate Bar ID:</strong>{" "}
                {row.mentorAdvocateBarId || "N/A"}
              </p>
              <p>
                <strong>Mentor Advocate Name:</strong>{" "}
                {row.mentorAdvocateName || "N/A"}
              </p>
              <p>
                <strong>Chamber No:</strong> {row.chamberNo || "N/A"}
              </p>
              <p>
                <strong>Mentor Joining Date:</strong>{" "}
                {row.joiningDate
                  ? new Date(row.joiningDate).toLocaleDateString()
                  : "N/A"}
              </p>
              <p>
                <strong>Experience In:</strong> {row.experienceIn}
              </p>
              <p>
                <strong>Previous Department:</strong>{" "}
                {row.previousDepartment || "N/A"}
              </p>
              <p>
                <strong>Retirement Year:</strong>{" "}
                {row.retirementYear
                  ? new Date(row.retirementYear).getFullYear()
                  : "N/A"}
              </p>
            </div>
            <div className="col-md-6">
              <p>
                <strong>Aadhar Document:</strong>{" "}
                {/* <a
                  href={`${baseURL}/File/view_aadhar_documnets/${extractFileNameAndExtension(
                    row.aadharCertificate
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a> */}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewDocument(
                      row,
                      "view_aadhar_documnets",
                      extractFileNameAndExtension(row.aadharDocument)
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-dark">View Document</span>
                </a>
              </p>
              {/* <p><strong>Advocacy Documents:</strong> <a href={`${API_BASE_URL}/File/view_advocacy_documnets/${extractFileNameAndExtension(row.advocacyDocuments)}`} target="_blank" rel="noopener noreferrer"><span className="text-dark">View Document</span></a></p> */}
              {/* <p><strong>AIBE Pass Certificate:</strong> <a href={`${API_BASE_URL}/File/view_aibe_pass_certificate/${extractFileNameAndExtension(row.aibePassCertificate)}`} target="_blank" rel="noopener noreferrer"><span className="text-dark">View Document</span></a></p> */}
              <p>
                <strong>Bar Association Membership Details:</strong>{" "}
                {row.barAssociationMembershipDetails || "N/A"}
              </p>
              {/* <p><strong>COP Certificate:</strong> <a href={`${API_BASE_URL}/File/view_cop_certificate/${extractFileNameAndExtension(row.copCertificate)}`} target="_blank" rel="noopener noreferrer"><span className="text-dark">View Document</span></a></p> */}
              <p>
                <strong>COP No:</strong> {row.copNo || "N/A"}
              </p>
              <p>
                <strong>COP Validity:</strong>{" "}
                {row.copValitidy
                  ? new Date(row.copValitidy).toLocaleDateString()
                  : "N/A"}
              </p>
              {/* <p><strong>Enrollment Certificate:</strong> <a href={`${API_BASE_URL}/File/view_enrollment_certificate/${extractFileNameAndExtension(row.enrollmentCertificate)}`} target="_blank" rel="noopener noreferrer"><span className="text-dark">View Document</span></a></p> */}
              <p>
                <strong>Enrollment No:</strong> {row.enrollmentNo || "N/A"}
              </p>
              {/* <p><strong>Fingerprint Data:</strong> {row.fingerprintData ? 'Available' : 'Not Available'}</p> */}
              {/* <p><strong>Fingerprint Image:</strong> {row.fingerprintImage ? <img src={row.fingerprintImage} alt="Fingerprint" /> : 'Not Available'}</p> */}
              <p>
                <strong>Is Another Bar Member:</strong>{" "}
                {row.isAnotherBarMember ? "Yes" : "No"}
              </p>
              {/* <p><strong>Photo:</strong> {row.photo ? <img src={row.photo} alt="Advocate" /> : 'Not Available'}</p> */}
              {/* <p><strong>Signature:</strong> {row.signature ? <img src={row.signature} alt="Signature" /> : 'Not Available'}</p> */}
              <p>
                <strong>Verification Date:</strong>{" "}
                {row.verificationDate
                  ? new Date(row.verificationDate).toLocaleDateString()
                  : "N/A"}
              </p>
              {/* <p><strong>Verification ID:</strong> {row.verificationId}</p> */}
              <p>
                <strong>Registration Date:</strong>{" "}
                {row.registrationDate
                  ? new Date(row.registrationDate).toLocaleDateString()
                  : "N/A"}
              </p>
              <p>
                <strong>Status:</strong> {row.status}
              </p>
            </div>
          </div>
          {/* <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        <Button variant="contained" color="success" onClick={() => handleAccept(row.id)}>
                            Accept
                        </Button>
                        <Button variant="contained" color="error" onClick={() => handleReject(row.id)}>
                            Reject
                        </Button>
                    </Box>
                    <p>Additional details can be added here...</p> */}
        </div>
      </Box>
    </Collapse>
  );

  const handleAccept = (id) => {
    console.log("Accepted:", id);
    // Handle accept action here
  };

  const handleReject = (id) => {
    console.log("Rejected:", id);
    // Handle reject action here
  };

  return (
    <>
      {loading && <Loader />}
      <div className="row justify-content-center mb-4">
        <div className="col-xxl-9">
          <div className="mt-5" style={{ height: height }}>
            <h2 className="mb-3 text-center">{tableName}</h2>
            <DataGrid
              rows={rows}
              columns={[
                {
                  field: "expand",
                  headerName: "",
                  width: 50,
                  filterable: false,
                  sortable: false,
                  hideable: false,

                  renderCell: (params) => (
                    <IconButton onClick={() => handleRowClick(params.row)}>
                      {expandedRowId === params.row.id ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </IconButton>
                  ),
                },
                ...columns,
              ]}
              slots={{
                toolbar: CustomToolbar,
              }}
              components={{ Toolbar: CustomToolbar }}
              disableRowSelectionOnClick
              hideFooterPagination
              getRowId={(row) => row.id}
            />
            {rows.map((row) => (
              <div key={row.id}>
                {expandedRowId === row.id && (
                  <div style={{ gridColumn: "1 / -1" }}>
                    {renderExpandableContent(row)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
